export const STORAGE_KEYS = {
  userId: 'userId',
  userName: 'userName',
  userType: 'userType',
};

export const authStorage = {
  getUserId: () => localStorage.getItem(STORAGE_KEYS.userId),
  getUserName: () => localStorage.getItem(STORAGE_KEYS.userName),
  getUserType: () => localStorage.getItem(STORAGE_KEYS.userType),
  setUserSession: ({ userId, userName, userType }) => {
    localStorage.setItem(STORAGE_KEYS.userId, userId);
    localStorage.setItem(STORAGE_KEYS.userName, userName);
    localStorage.setItem(STORAGE_KEYS.userType, userType);
  },
  clearUserSession: () => {
    localStorage.removeItem(STORAGE_KEYS.userId);
    localStorage.removeItem(STORAGE_KEYS.userName);
    localStorage.removeItem(STORAGE_KEYS.userType);
  },
};
